import React from 'react';
import styled from 'styled-components';
import { FieldHelperProps, FieldInputProps, useField } from 'formik';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { ComponentPropBase } from '../../types';
import { SmartformContextProps } from '../../forms/controllers/SmartformContext';
import { useFieldSmartFormContext, useSmartFormContext } from '../../forms/utils/useSmartFormContext';
import { InfoText } from '../../atoms/InfoText/InfoText';
import { PermissionHelper } from '../../atoms';

export interface CommonFieldProps extends ComponentPropBase {
  fullWidth?: boolean;
  onRender: (
    disabled: boolean,
    context: Partial<SmartformContextProps>,
    input: FieldInputProps<any>,
    helpers: FieldHelperProps<any>
  ) => JSX.Element;
}

const CommonField: React.FC<CommonFieldProps> = (props) => {
  const context = useSmartFormContext();
  let {
    label,
    name,
    errors,
    error,
    helpText,
    helpTextBelow,
    infoText,
    touched,
    type,
    disabled,
    required,
    fullWidth = true,
    onRender,
    ...rest
  } = props;

  const { getFieldPermissions, permissionDebugger, getDisabled, readonly } = useFieldSmartFormContext(name);

  const [input, , helpers] = useField(name || 'INVALID');
  const permissions = getFieldPermissions(name);

  if (getDisabled(name) || readonly) {
    disabled = true;
  }

  return (
    <FormControl
      error={!!errors && !!touched}
      required={required}
      fullWidth={fullWidth}
      data-test={`${name}-field-control`}
      className="field-control"
      {...rest}
    >
      {label && (
        <StyledInputLabel error={error} data-test={`${name}-field-label`} shrink>
          <InfoText label={label} required={required} tooltipText={infoText} />
        </StyledInputLabel>
      )}
      {helpText && !helpTextBelow && (
        <StyledHelperText $error={!!error} data-test={`${name}-field-helper`} id={`${name}-helper-text`}>
          {helpText}
        </StyledHelperText>
      )}
      {onRender(disabled || false, context, input, helpers)}
      {helpTextBelow && helpText && (
        <StyledHelperText $error={!!error} data-test={`${name}-field-helper`} id={`${name}-helper-text`} helpTextBelow>
          {helpText}
        </StyledHelperText>
      )}
      {permissionDebugger && <PermissionHelper permission={permissions} />}
    </FormControl>
  );
};

const StyledInputLabel = styled(InputLabel)`
  margin-bottom: 8px;
`;

const StyledHelperText = styled.div<{ $error: boolean; helpTextBelow?: boolean }>`
  margin-top: ${({ helpTextBelow }) => (helpTextBelow ? '8px' : 0)};
  font-size: 14px;
  color: ${({ $error, theme }) => ($error ? theme.colorAlert : '')};
`;

export { CommonField };
